import React, { useContext, useEffect } from 'react'
import { Container, SpinnerContainer } from './Overview.style'
import { useQuery } from '@apollo/client'
import GET_ERRORFLOW_PRICE from '@graphql/queries/getCarpayErrorFlowPrice.query'
import Spinner from 'parkdepot-shared/components/Spinner'
import CarpayOrderActions from '@components/CarpayOrderActions/CarpayOrderActions.component'
import FreeOrderCard from '@components/CarpayOrderCard/Cards/FreeOrderCard.component'
import EnforcedCarpayOrderCard from '@components/CarpayOrderCard/Cards/EnforcedCarpayOrderCard.component'
import { CARPAY_STATUS } from 'parkdepot-shared/models/database'
import UnpaidCarpayOrderCard from '@components/CarpayOrderCard/Cards/UnpaidCarpayOrderCard.component'
import { ErrorFlowContext } from '@context/ErrorFlowContext/errorFlow.context'
import { useTranslation } from 'react-i18next'
import Error from '@components/Error/Error.component'

const CarpayLPNotFoundOverview = () => {
    const { t } = useTranslation()
    const { errorFlow, setErrorFlow } = useContext(ErrorFlowContext)
    const dataMissing = !errorFlow?.lot?.id || !errorFlow?.plate || !errorFlow?.country || !errorFlow?.start_datetime

    const { data, loading, error } = useQuery(GET_ERRORFLOW_PRICE, {
        variables: {
            lot_id: errorFlow?.lot?.id || '',
            plate: errorFlow?.plate || '',
            country: errorFlow?.country || '',
            start_date: errorFlow?.start_datetime || '',
            end_date: errorFlow?.end_datetime || null,
            selected_parking_tariff: errorFlow.selectedTariff || null,
            parking_context_uuid: errorFlow.selectedContext || null
        },
        skip: dataMissing
    })

    const price = data?.b2c_get_errorflow_price?.price
    const lot = data?.b2c_get_errorflow_price?.lot
    const order = data?.b2c_get_errorflow_price?.order
    const priceToBePaid = price?.discounted_parking_price || 0

    useEffect(() => {
        if (priceToBePaid > 0) {
            setErrorFlow({
                ...errorFlow,
                price_valid_until: price?.price_valid_until
            })
        }
    }, [priceToBePaid])

    if (loading) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error) {
        return (
            <Container>
                <p>{t('errors.errorOnSave')}</p>
            </Container>
        )
    }

    if (dataMissing) {
        return <Error />
    }

    // for free orders
    if (!priceToBePaid && order && errorFlow)
        return (
            <FreeOrderCard end_date={order.end_date || ''} plate={order.plate} country={errorFlow?.country || 'int'} />
        )

    return (
        <Container>
            {order && lot && (
                <>
                    {order.status === CARPAY_STATUS.UNPAID || order.status === CARPAY_STATUS.INCOMPLETE ? (
                        <>
                            {/* order needs to be paid */}
                            <UnpaidCarpayOrderCard
                                order={order}
                                currency={price?.currency || 'EUR'}
                                lot={lot}
                                fullyWhitelisted
                                priceToBePaid={priceToBePaid}
                                isLast={false}
                                disabled={false}
                                onClick={() => {}}
                                paymentDeadline={price?.payment_deadline}
                            />
                            <CarpayOrderActions orderData={data?.b2c_get_errorflow_price} allowDiscountOption={false} />
                        </>
                    ) : (
                        // orders that are enforced - can't pay anymore
                        <EnforcedCarpayOrderCard
                            order={order}
                            lot={lot}
                            priceToBePaid={priceToBePaid}
                            currency={price?.currency || 'EUR'}
                            isLast={false}
                            disabled={false}
                            onClick={() => {}}
                            fullyWhitelisted={false}
                        />
                    )}
                </>
            )}
        </Container>
    )
}

export default CarpayLPNotFoundOverview
